import { motion } from "framer-motion";
import { ShieldCheck, Mountain } from "lucide-react";

// Animated green AlpineCar "ELLENŐRIZVE" inspection stamp.
// Entrance plays once on mount (page open), then stays visible.
// `compact` renders a smaller variant (e.g. next to the car name on mobile).
export const InspectionStamp = ({ className = "", compact = false }) => {
  return (
    <div className={`relative select-none pointer-events-none ${className}`} data-testid="inspection-stamp">
      {/* Impact glow flash (one-shot) */}
      <motion.div
        aria-hidden="true"
        className="absolute inset-0 rounded-[16px]"
        style={{ background: "radial-gradient(ellipse at 50% 50%, rgba(16,185,129,0.55), transparent 70%)", filter: "blur(12px)" }}
        initial={{ opacity: 0, scale: 0.7 }}
        animate={{ opacity: [0, 0, 0.9, 0.25], scale: [0.7, 0.7, 1.15, 1] }}
        transition={{ duration: 1.0, delay: 0.55, times: [0, 0.45, 0.72, 1], ease: "easeOut" }}
      />

      {/* The stamp seal */}
      <motion.div
        className="relative"
        initial={{ opacity: 0, scale: 1.7, rotate: -24, y: -40, x: 18 }}
        animate={{
          opacity: [0, 1, 1, 1, 1],
          scale: [1.7, 1.18, 0.9, 1.03, 1],
          rotate: [-24, -15, -6, -9.5, -8],
          y: [-40, -8, 5, -1, 0],
          x: [18, 6, 0, 1, 0],
        }}
        transition={{ duration: 0.95, delay: 0.6, times: [0, 0.42, 0.68, 0.86, 1], ease: [0.22, 1, 0.36, 1] }}
      >
        <div
          className={compact ? "relative rounded-[11px] px-2.5 py-2" : "relative rounded-[15px] px-4 py-3 sm:px-5 sm:py-3.5"}
          style={{
            background: "linear-gradient(135deg, rgba(6,44,28,0.82) 0%, rgba(9,64,38,0.62) 55%, rgba(4,34,22,0.82) 100%)",
            border: compact ? "2px solid rgba(52,211,153,0.9)" : "2.5px solid rgba(52,211,153,0.9)",
            boxShadow: "0 0 22px rgba(16,185,129,0.5), 0 8px 22px rgba(0,0,0,0.5), inset 0 0 18px rgba(16,185,129,0.22)",
            backdropFilter: "blur(3px)",
          }}
        >
          {/* Inner ring for a double-stamp border look */}
          <div className={`absolute pointer-events-none ${compact ? "inset-[2px] rounded-[8px]" : "inset-[3px] rounded-[11px]"}`} style={{ border: "1px solid rgba(110,231,183,0.45)" }} />

          <div className={`relative flex items-center ${compact ? "gap-2" : "gap-3"}`}>
            {/* Emblem */}
            <div
              className={`flex-shrink-0 rounded-lg flex items-center justify-center ${compact ? "w-8 h-8" : "w-11 h-11 sm:w-12 sm:h-12 rounded-xl"}`}
              style={{ border: "1.5px solid rgba(110,231,183,0.7)", background: "rgba(6,44,28,0.5)", boxShadow: "0 0 12px rgba(16,185,129,0.4)" }}
            >
              <ShieldCheck className={compact ? "w-4 h-4" : "w-6 h-6 sm:w-7 sm:h-7"} style={{ color: "#6ee7b7", filter: "drop-shadow(0 0 6px rgba(16,185,129,0.7))" }} />
            </div>

            {/* Text block */}
            <div className={compact ? "" : "pr-1"}>
              <div className="flex items-center gap-1" style={{ color: "#a7f3d0" }}>
                <Mountain className={compact ? "w-2.5 h-2.5" : "w-3 h-3"} style={{ filter: "drop-shadow(0 0 4px rgba(16,185,129,0.6))" }} />
                <span className={`font-bold tracking-[0.22em] uppercase ${compact ? "text-[7px]" : "text-[9px] sm:text-[10px] tracking-[0.28em]"}`}>AlpineCar</span>
              </div>
              <div
                className={`font-display font-extrabold leading-none uppercase tracking-wide mt-1 ${compact ? "text-[13px]" : "text-lg sm:text-xl"}`}
                style={{ color: "#6ee7b7", textShadow: "0 0 12px rgba(16,185,129,0.75), 0 1px 0 rgba(0,0,0,0.4)" }}
              >
                ✓ Ellenőrizve
              </div>
              <div className={`font-semibold tracking-[0.18em] uppercase mt-1 ${compact ? "text-[6px]" : "text-[9px] sm:text-[10px]"}`} style={{ color: "rgba(167,243,208,0.8)" }}>
                A jármű átvizsgálva
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};
